/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Bring_CtaInputs */

const en_funnel_ob_bring_cta = /** @type {(inputs: Funnel_Ob_Bring_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nice`)
};

const es_funnel_ob_bring_cta = /** @type {(inputs: Funnel_Ob_Bring_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genial`)
};

/**
* | output |
* | --- |
* | "Nice" |
*
* @param {Funnel_Ob_Bring_CtaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_bring_cta = /** @type {((inputs?: Funnel_Ob_Bring_CtaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Bring_CtaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_bring_cta(inputs)
	return en_funnel_ob_bring_cta(inputs)
});